import Vue from 'vue';
import Vuex from 'vuex';
import modules from './modules';
Vue.use(Vuex);
const store = new Vuex.Store({
    state: {},
    mutations: {},
    actions: {},
    modules,
});
export default store;
